import { Injectable } from '@angular/core';
import { StorageService } from '@services/storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Currency } from '@interfaces/index';

export type CurrencyType = 'USD' | 'EUR' | 'GBP';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currentCurrency!: CurrencyType;
  private currentCurrencySubject$!: BehaviorSubject<CurrencyType>;
  currentCurrency$!: Observable<CurrencyType>;

  constructor(private storage: StorageService) {
    this.currentCurrency = this.storage.get('currency', 'USD');
    this.currentCurrencySubject$ = new BehaviorSubject<CurrencyType>(
      this.currentCurrency
    );
    this.currentCurrency$ = this.currentCurrencySubject$.asObservable();
  }

  setCurrency(currency: CurrencyType) {
    this.currentCurrency = currency;
    this.storage.set('currency', this.currentCurrency);
    this.currentCurrencySubject$.next(currency);
  }

  getCurrencies(): Currency[] {
    return [
      { symbol: '$', code: 'USD' },
      // temporary disable other currencies
      // { symbol: '&euro;', code: 'EUR' },
      // { symbol: '&pound;', code: 'GBP' },
    ];
  }
}
